import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.navIcon = this.element.querySelector('.nav-icon') || this.element.querySelector('.welcome-nav-icon');
    this.menuClosedLabel = this.element.querySelector('#menu-closed-label');
    this.menuOpenLabel = this.element.querySelector('#menu-open-label');
    this.mobileMenu = document.querySelector('.mobile-menu');
    $(this.menuOpenLabel).hide();
  }

  toggleMenu(e) {
    e.preventDefault();
    this.navIcon.classList.toggle('open');
    this.mobileMenu.classList.toggle('hidden');
    this.element.closest('header')?.classList.toggle('mobile-menu-open');
    this.element.setAttribute('aria-expanded', String(this.navIcon.classList.contains('open')));
    $(this.menuClosedLabel).toggle();
    $(this.menuOpenLabel).toggle();
  }
}
